var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendlyBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#C8E6C9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12.5,
    stroke: "#18181B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.24 17.6c.56.952 1.576 1.6 2.76 1.6 1.184 0 2.2-.648 2.76-1.6h1.336a4.396 4.396 0 01-8.192 0h1.336zM8 16c0-4.416 3.576-8 7.992-8C20.416 8 24 11.584 24 16s-3.584 8-8.008 8C11.576 24 8 20.416 8 16zm1.6 0c0 3.536 2.864 6.4 6.4 6.4 3.536 0 6.4-2.864 6.4-6.4 0-3.536-2.864-6.4-6.4-6.4A6.398 6.398 0 009.6 16zm3.6-.8a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zm5.6 0a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4z",
    fill: "#27272A"
  })));
}
export default SvgFriendlyBadge;